
// 扩展 window 接口
import CallJSS from "@/Core/Bridge/CallJSS";
import ErrorMgr from "@/Fwk/ErrorMgr";
import Util from "@/Master/Util";
import DBMgr from "@/Core/DBMgr";
import RandomUtil from "@/Master/RandomUtil";
import ChannelMgr from "@/Fwk/Channel/ChannelMgr";
import AESHelper from "@/Fwk/Encrypt/AESHelper";
import DataMgr from "@/Fwk/DataMgr";
import CookieMgr from "@/Fwk/CookieMgr";
import UserGlobalMgr from "@/Core/UserGlobalMgr";
import KitAPI from "@/Fwk/Kit/KitAPI";
import GameMsgUtil from "@/app/(game)/GameMsgUtil";
import KitPwa from "@/Master/PWA/KitPwa";
import FrameOrientMgr from "@/Master/FrameOrient/FrameOrientMgr";
import AIHelp from "@/Core/AIHelp/AiHelpChat";
import UtilUrl from "@/Core/UtilUrl";
import RouterMgr from "@/Core/RouterMgr";
import UtilBrowser from "@/Master/UtilBrowser";
import SdkTrack from "@/Fwk/Kit/SdkTrack";
import UtilUnity from "@/app/(game)/unity-game/UtilUnity";
// import {GuideData} from "@/Core/GuideMgr";


declare global {
    interface Window {
        callJSS?: typeof CallJSS;

        createUnityInstance?:any,
        // unityInstance?: {
        //     SendMessage: (objectName: string, methodName: string, message: string) => void;
        // };
        unityInstance:any,

        iframeWindow:any,

        KitError: typeof ErrorMgr;
        DBMgr: typeof DBMgr;
        DataMgr: typeof DataMgr;
        RandomUtil: typeof RandomUtil;
        AdjustMgr: typeof ChannelMgr;
        AESHelper: typeof AESHelper;
        CookieMgr: typeof CookieMgr;
        UserMgr: typeof UserGlobalMgr;
        Util: typeof Util;
        KitAPI: typeof KitAPI;
        GameMsgUtil: typeof GameMsgUtil;
        KitPwa: typeof KitPwa;
        FrameOrientMgr: typeof FrameOrientMgr;
        // AIHelp: typeof AIHelp;
        AIHelpSupport: typeof AIHelpSupport;
        UtilUrl: typeof UtilUrl;
        RouterMgr: typeof RouterMgr;
        UtilBrowser: typeof UtilBrowser;
        SdkTrack: typeof SdkTrack;
        UtilUnity: typeof UtilUnity;
    }
}

export default class WindowGlobal {
    static Init(){

        //完整暴露出去
        if (Util.isWindow){
            window.callJSS = CallJSS;
            // window.AIHelp = AIHelp;
        }

        //测试环境使用
        if (Util.isWindow){
            window.KitError = ErrorMgr;
            window.DBMgr = DBMgr;
            window.DataMgr = DataMgr;
            window.RandomUtil = RandomUtil;
            window.AdjustMgr = ChannelMgr;
            window.AESHelper = AESHelper;
            window.CookieMgr = CookieMgr;
            window.UserMgr = UserGlobalMgr;
            window.Util = Util;
            window.KitAPI = KitAPI;
            window.GameMsgUtil = GameMsgUtil;
            window.KitPwa = KitPwa;
            window.FrameOrientMgr = FrameOrientMgr;
            window.UtilUrl = UtilUrl;
            window.RouterMgr = RouterMgr;
            window.UtilBrowser = UtilBrowser;
            window.SdkTrack = SdkTrack;
            window.UtilUnity = UtilUnity;
        }

    }

}